export const canNotify = () => "Notification" in window;

export const requestNotifyPermission = async () => {
    if (!canNotify()) return false;

    // ✅ Уже разрешено — ок
    if (Notification.permission === "granted") return true;

    // ❌ Уже заблокировано — не дергаем requestPermission()
    if (Notification.permission === "denied") return false;

    // ✅ Запрашиваем ТОЛЬКО если статус default
    const res = await Notification.requestPermission();
    return res === "granted";
};

export const showNotification = ({ title, body, url }) => {
    if (!canNotify()) return;

    if (Notification.permission !== "granted") return;

    const n = new Notification(title, {
        body,
        icon: "/favicon.ico",
        tag: "arento-chat",
        renotify: true,
    });

    n.onclick = () => {
        window.focus();
        if (url) window.location.href = url;
        n.close();
    };
};
